// extracted by mini-css-extract-plugin
export var Section404 = "_404-module--Section404--1_m1G";
export var content = "_404-module--content--1SFxU";
export var bubbleContent = "_404-module--bubbleContent--3MzPQ";
export var highlight = "_404-module--highlight--2EPvi";
export var body = "_404-module--body--1X7Ng";
export var image = "_404-module--image--2rtQQ";